import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import getBlogs from '../config/blogs';
import { Helmet } from 'react-helmet';
import { SuperSEO } from 'react-super-seo';

function BlogDetail() {
    const { slug } = useParams();
    const blogs = getBlogs();
    const blog = blogs.find(b => b.slug === slug);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [slug]);

    if (!blog) {
        return (
            <div className="container py-5 text-center my-5">
                <h2 className="text-danger font-weight-bold">404 - Article Not Found</h2>
                <p className="text-muted mb-4">The blog post you are looking for does not exist or has been moved.</p>
                <Link to="/blogs" className="btn btn-primary py-3 px-5" style={{ borderRadius: '30px' }}>Back to Blogs</Link>
            </div>
        );
    }

    const canonicalUrl = `https://www.aapligaadi.co.in/blogs/${blog.slug}`;

    return (
        <>
            <Helmet>
                <link rel="canonical" href={canonicalUrl} />
            </Helmet>
            <SuperSEO
                title={`${blog.title} | Aapli Gaadi Blog`}
                description={blog.summary}
                lang="en"
                openGraph={{
                    ogTitle: `${blog.title} - Aapli Gaadi Blog`,
                    ogDescription: blog.summary,
                    ogUrl: canonicalUrl,
                    ogType: "article",
                    ogImage: { ogImage: `${process.env.PUBLIC_URL}/image/blogs/${blog.image}` },
                    ogSiteName: "Aapli Gaadi",
                    ogLocale: "en_US"
                }}
            />

            {/* Title Banner */}
            <div 
                className="hero-wrap d-flex align-items-center" 
                style={{ 
                    backgroundImage: `url('${process.env.PUBLIC_URL}/image/blogs/${blog.image}')`, 
                    backgroundSize: 'cover', 
                    backgroundPosition: 'center', 
                    height: '450px',
                    position: 'relative'
                }}
            >
                <div className="overlay" style={{ content: '""', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, opacity: 0.6, background: '#000000' }}></div>
                <div className="container" style={{ position: 'relative', zIndex: 2 }}>
                    <div className="row justify-content-center">
                        <div className="col-lg-10 text-center">
                            <span className="badge badge-primary py-2 px-3 mb-3" style={{ fontSize: '13px', borderRadius: '20px' }}>{blog.category}</span>
                            <h1 className="text-white font-weight-bold mb-4" style={{ fontSize: '42px', lineHeight: '1.2', textShadow: '2px 2px 4px rgba(0,0,0,0.6)' }}>
                                {blog.title}
                            </h1>
                            <div className="meta d-flex justify-content-center align-items-center text-white" style={{ fontSize: '14px', opacity: 0.9 }}>
                                <div className="mx-2"><span className="fa fa-calendar mr-1"></span>{blog.date}</div>
                                <div className="mx-2"><span className="fa fa-user mr-1"></span>By {blog.author}</div>
                                <div className="mx-2"><span className="fa fa-clock mr-1"></span>{blog.readTime}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Blog Post Content Body */}
            <section className="ftco-section bg-white">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-10">
                            {/* Back Button */}
                            <div className="mb-4">
                                <Link to="/blogs" className="text-primary font-weight-bold d-flex align-items-center" style={{ fontSize: '15px', textDecoration: 'none' }}>
                                    <span className="fa fa-arrow-left mr-2"></span> Back to all blogs
                                </Link>
                            </div>

                            {/* Render Content Blocks */}
                            <article className="blog-detail-content" style={{ fontSize: '16px', lineHeight: '1.8', color: '#444' }}>
                                {blog.content.map((block, idx) => {
                                    switch (block.type) {
                                        case 'heading':
                                            return (
                                                <h2 
                                                    key={idx} 
                                                    className="text-dark font-weight-bold mt-5 mb-4" 
                                                    style={{ fontSize: '26px', borderLeft: '4px solid #ffbc00', paddingLeft: '15px' }}
                                                >
                                                    {block.text}
                                                </h2>
                                            );
                                        case 'list':
                                            return (
                                                <ul key={idx} className="pl-4 my-4" style={{ listStyleType: 'disc' }}>
                                                    {block.items?.map((item, itemIdx) => (
                                                        <li key={itemIdx} className="mb-3" style={{ fontSize: '16px' }}>
                                                            {item}
                                                        </li>
                                                    ))}
                                                </ul>
                                            );
                                        case 'paragraph':
                                        default:
                                            return (
                                                <p key={idx} className="mb-4" style={{ textAlign: 'justify' }}>
                                                    {block.text}
                                                </p>
                                            );
                                    }
                                })}
                            </article>

                            {/* Call To Action Box */}
                            <div className="mt-5 p-4 rounded bg-light border d-flex flex-wrap align-items-center justify-content-between">
                                <div className="mb-3 mb-md-0">
                                    <h4 className="font-weight-bold text-dark mb-1" style={{ fontSize: '18px' }}>Planning your Konkan trip?</h4>
                                    <p className="text-muted mb-0" style={{ fontSize: '14px' }}>Rent a self-drive car or hire a vehicle with driver to explore local routes easily!</p>
                                </div>
                                <Link to="/" className="btn btn-primary py-2 px-4" style={{ borderRadius: '30px', fontWeight: 600 }}>Book A Car Now</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default BlogDetail;
